// HomeBrief.jsx -- Hub View home state, Brief-first
// Wraps MorningBrief with greeting, clickable card behavior, trust footer
// Brief is the jumping-off point: tap cards to drill into departments/agents
// ASCII only. var declarations. ESM only. Inline styles.

import { useContext, useState, useEffect } from 'react';
import { ThemeContext } from '../../lib/theme.js';
import MorningBrief from '../daily/MorningBrief.jsx';
import { ConnectToolsCard } from '../daily/Primitives.jsx';

export default function HomeBrief(props) {
  var onNavigate = props.onNavigate || function() {};
  var impUrl = props.impUrl || function(u) { return u; };
  var userName = props.userName || '';
  var firstName = userName ? userName.split(' ')[0] : '';

  var theme = useContext(ThemeContext);

  var _connectors = useState(null);
  var connectors = _connectors[0]; var setConnectors = _connectors[1];

  function fetchConnectors() {
    fetch(impUrl('/api/connectors'))
      .then(function(r) { return r.json(); })
      .then(function(j) {
        var items = (j.ok && j.data && j.data.items) ? j.data.items : (Array.isArray(j.data) ? j.data : []);
        setConnectors(items);
      })
      .catch(function() { setConnectors([]); });
  }

  useEffect(function() {
    fetchConnectors();
  }, []);

  function handleConnect(toolId) {
    var googleProviders = { gmail: 1, calendar: 1, google_drive: 1 };
    var endpoint = googleProviders[toolId] ? '/api/connectors/connect-google/' + toolId : '/api/connectors/connect/' + toolId;
    fetch(impUrl(endpoint), { method: 'POST' })
      .then(function(r) { return r.json(); })
      .then(function(j) {
        var url = j.ok && j.data && j.data.auth_url;
        if (url) {
          var popup = window.open(url, 'hub_oauth', 'width=500,height=600');
          // Poll for popup close, then re-fetch connector state
          var pollId = setInterval(function() {
            if (!popup || popup.closed) {
              clearInterval(pollId);
              // Small delay for DB write to complete before re-fetching
              setTimeout(fetchConnectors, 1000);
            }
          }, 500);
        }
      })
      .catch(function() {});
  }

  var _briefCards = useState(null);
  var briefCards = _briefCards[0];
  var setBriefCards = _briefCards[1];

  var _isDemo = useState(false);
  var isDemo = _isDemo[0]; var setIsDemo = _isDemo[1];
  var _generating = useState(false);
  var generating = _generating[0]; var setGenerating = _generating[1];

  useEffect(function() {
    fetch('/api/hub/current', { credentials: 'include' })
      .then(function(r) { return r.json(); })
      .then(function(d) {
        if (d.ok && d.data && d.data.hub_id && d.data.hub_id.indexOf('demo_') === 0) setIsDemo(true);
      })
      .catch(function() {});
  }, []);

  function loadBriefCards() {
    fetch(impUrl('/api/brief/cards'))
      .then(function(r) { return r.json(); })
      .then(function(j) {
        if (j.ok && j.data && j.data.cards) {
          var cards = j.data.cards;
          var h = new Date().getHours();
          var localGreeting = h < 12 ? 'Good morning' : h < 17 ? 'Good afternoon' : 'Good evening';
          for (var ci = 0; ci < cards.length; ci++) {
            if (cards[ci].type === 'greeting' && cards[ci].text) {
              cards[ci].text = cards[ci].text.replace(/Good (morning|afternoon|evening)/, localGreeting);
            }
          }
          setBriefCards(cards);
        }
      })
      .catch(function() {});
  }

  useEffect(function() { loadBriefCards(); }, []);

  function handleGenerateBrief() {
    setGenerating(true);
    fetch(impUrl('/api/brief/generate'), {
      method: 'POST', credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({})
    })
      .then(function(r) { return r.json(); })
      .then(function() {
        setTimeout(function() { loadBriefCards(); setGenerating(false); }, 2000);
      })
      .catch(function() { setGenerating(false); });
  }

  function handleAction(action, item) {
    if (!action) return;
    // Approval card actions: POST to agent action endpoint
    if (action.type === 'approve' || action.type === 'reject' || action.type === 'action') {
      var agentId = item && item.agent;
      if (agentId && action.endpoint) {
        fetch(impUrl(action.endpoint), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ action: action.type, cardId: item && item.id })
        }).catch(function() {});
      }
      return;
    }
    // Navigate to agent work surface
    if (action.type === 'agent' && action.id) {
      onNavigate('agent', action.id);
      return;
    }
    // Navigate to department
    if (action.type === 'dept' && action.id) {
      onNavigate('dept', action.id);
      return;
    }
    // Financial metric tap -> finance dept
    if (action.type === 'metric') {
      onNavigate('dept', 'finance');
    }
  }

  var h = new Date().getHours();
  var greeting = h < 12 ? 'Good morning' : h < 17 ? 'Good afternoon' : 'Good evening';

  return (
    <div style={{ padding: 24, maxWidth: 640 }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
        <div>
          <div style={{ fontSize: 22, fontWeight: 700, marginBottom: 2, color: theme.text }}>{greeting}{firstName ? ', ' + firstName + '.' : '.'}</div>
          <div style={{ fontSize: 13, color: theme.textSecondary, marginBottom: 14 }}>Here is your Brief.</div>
        </div>
        <div onClick={function() { window.open('/?popout=center', '_blank', 'width=900,height=700'); }}
          title="Pop out Brief"
          style={{ width: 28, height: 28, borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: theme.textMuted, flexShrink: 0, marginTop: 4 }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6"/><polyline points="15,3 21,3 21,9"/><line x1="10" y1="14" x2="21" y2="3"/>
          </svg>
        </div>
      </div>

      {/* Connect tools card (shows when connectors missing) */}
      {connectors && (function() {
        var connectedIds = connectors.map(function(c) { return (c.provider || c.type || '').toLowerCase(); });
        function isConn(id) { return connectedIds.indexOf(id) >= 0; }
        var personalTools = [
          { id: 'gmail', icon: 'M', label: 'Gmail', desc: 'Read invoices, client emails, receipts', color: '#EA4335', connected: isConn('gmail') || isConn('google') },
          { id: 'calendar', icon: 'C', label: 'Google Calendar', desc: 'Track meetings, prep agendas, schedule', color: '#4285F4', connected: isConn('calendar') || isConn('google_calendar') },
          { id: 'google_drive', icon: 'D', label: 'Google Drive', desc: 'Shared docs, contracts, spreadsheets', color: '#0F9D58', connected: isConn('google_drive') },
          { id: 'slack', icon: 'S', label: 'Slack', desc: 'Listen to team questions, route to agents', color: '#4A154B', connected: isConn('slack') },
        ];
        var orgTools = [
          { id: 'quickbooks', icon: 'Q', label: 'QuickBooks', desc: 'Financials, invoices, P&L', color: '#2CA01C', connected: isConn('quickbooks') },
          { id: 'stripe', icon: '$', label: 'Stripe', desc: 'Revenue, subscriptions, payments', color: '#635BFF', connected: isConn('stripe'), apiKey: true },
          { id: 'plaid', icon: 'P', label: 'Plaid', desc: 'Bank accounts, transactions, cash position', color: '#00D09C', connected: isConn('plaid'), apiKey: true },
          { id: 'ramp', icon: 'R', label: 'Ramp', desc: 'Expenses, corporate cards, reimbursements', color: '#F2C94C', connected: isConn('ramp'), apiKey: true },
          { id: 'deel', icon: 'D', label: 'Deel', desc: 'Payroll, contractors, global team', color: '#15357A', connected: isConn('deel'), apiKey: true },
          { id: 'jira', icon: 'J', label: 'Jira', desc: 'Tickets, sprints, engineering velocity', color: '#0052CC', connected: isConn('jira'), apiKey: true },
        ];
        return <ConnectToolsCard theme={theme} personalTools={personalTools} orgTools={orgTools} onConnect={handleConnect} />;
      })()}

      {/* Brief compression bar */}
      {briefCards && (function() {
        var actionable = briefCards.filter(function(c) { return c.type !== 'greeting' && c.type !== 'section_label'; });
        var handled = briefCards.filter(function(c) { return c.type === 'status_update'; });
        var total = Math.max(1, actionable.length);
        var pct = Math.round((handled.length / total) * 100);
        var color = pct >= 75 ? (theme.success || '#10B981') : pct >= 40 ? '#0891B2' : (theme.warning || '#F59E0B');
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 14, padding: '6px 10px', background: theme.surfaceInset || '#f0efe9', borderRadius: 6 }}>
            <span style={{ fontSize: 11, color: theme.textSecondary || '#6b6962', fontFamily: "'IBM Plex Sans', sans-serif" }}>
              Brief: <b style={{ fontWeight: 600 }}>{actionable.length} items</b> today
            </span>
            <div style={{ flex: 1, height: 4, borderRadius: 2, background: theme.border || '#e5e3dc' }}>
              <div style={{ width: Math.max(3, pct) + '%', height: '100%', background: color, borderRadius: 2, transition: 'width 0.5s ease' }} />
            </div>
            <span style={{ fontSize: 10, fontFamily: "'IBM Plex Mono', monospace", color: color, fontWeight: 500 }}>{pct}% autonomous</span>
          </div>
        );
      })()}

      {generating && (
        <div style={{ textAlign: 'center', padding: '12px 0', fontSize: 11, color: theme.accent }}>Generating fresh brief cards...</div>
      )}
      <MorningBrief items={briefCards} onAction={handleAction} isDemo={isDemo} onGenerateBrief={generating ? null : handleGenerateBrief} />

      <div style={{ fontSize: 10, color: theme.textMuted, textAlign: 'center', padding: '12px 0', borderTop: '1px solid ' + theme.border, lineHeight: 1.6 }}>
        As your agents earn trust, Brief gets shorter. The goal: nothing needs you.
      </div>
    </div>
  );
}
